/**
 * Challenge Data Model
 *
 * Challenges are content creation opportunities that employees can participate in.
 * When employees submit content for a challenge and it gets approved,
 * they earn points.
 */
export var ChallengeStatus;
(function (ChallengeStatus) {
    ChallengeStatus["DRAFT"] = "draft";
    ChallengeStatus["ACTIVE"] = "active";
    ChallengeStatus["COMPLETE"] = "complete";
    ChallengeStatus["ARCHIVED"] = "archived";
})(ChallengeStatus || (ChallengeStatus = {}));
/**
 * Data access patterns:
 *
 * 1. Get challenge by ID
 *    - Primary key query: challengeId
 *
 * 2. List all challenges for a company
 *    - GSI query: CompanyChallengesIndex (partitionKey: companyId)
 *
 * 3. List submissions for a challenge
 *    - See Submission model in models/Submission.ts
 */
